import React, { useEffect, useRef } from 'react';
import user from '../Assets/user.png';
import { RiSettings2Line, RiLogoutBoxRLine } from 'react-icons/ri'; 
import { NavLink } from 'react-router-dom';

function SideNav({ isOpen, onClose }) {
  const sideNavRef = useRef(null);

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sideNavRef.current && !sideNavRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <div
      ref={sideNavRef}
      className={`text-lg text-black border-[1px] rounded-3xl shadow-md bg-white w-[280px] 
      absolute top-0 px-8 transition-transform duration-500 
      ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
    >
      <div className="py-6 flex flex-col gap-6">
        {/* Header with user profile */}
        <div className="flex flex-row items-center gap-4">
          <img src={user} alt="User Avatar" className="w-[4rem] h-[4rem] rounded-full object-cover" />

          {/* Optional Close Button */}
          {/* <div
            className="text-2xl font-semibold cursor-pointer text-gray-600 hover:text-red-500"
            onClick={onClose}
          >
            &times;
          </div> */}
        </div>

        {/* Divider */}
        <div className="w-full border-t border-gray-300" />

        {/* Profile performance section */}
        <div className="flex flex-col gap-6">
          <p className="font-semibold text-lg text-gray-700">Your Profile Performance</p>
          <div className="bg-blue-100 rounded-3xl w-full p-4 space-y-6">
            {/* Profile stats */}
            {['Search Appearances', 'Recruiter Actions'].map((item, index) => (
              <div key={index} className="flex flex-col items-center">
                <p className="font-semibold text-2xl text-blue-600">0</p>
                <p className="text-base">{item}</p>
                <a href="/" className="text-blue-500 text-sm hover:underline">
                  View All
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Menu Items */}
        <div className="flex flex-col gap-4">
          <NavLink to="/settings">
            <div className="flex items-center gap-3 text-base hover:bg-gray-100 p-2 rounded-xl cursor-pointer">
              <RiSettings2Line className="text-lg text-gray-600" />
              <p className="text-gray-700">Settings</p>
            </div>
          </NavLink>

          <NavLink to="/">
            <div className="flex items-center gap-3 text-base hover:bg-gray-100 p-2 rounded-xl cursor-pointer">
              <RiLogoutBoxRLine className="text-lg text-gray-600" />
              <p className="text-gray-700">Log Out</p>
            </div>
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default SideNav;
